import { createRouter, createWebHistory } from "vue-router";
import { routes } from "@/routing/routes";
import { scrollTop } from "@/assets/js/components/util";
import { checkForNavigationByCategory } from "@/routing/guards/checkForNavigationByCategory";
import Layout from "@/view/layout/Layout.vue";
import buybackRouterWeb from "@/apps/whiteLabelWebsite/buyback/routing/router";
import routerWhiteLabel from "@/apps/whiteLabelWebsite/whiteLabel/routing/router";

const routerWeb = createRouter({
  history: createWebHistory(),
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: routes.home.path,
      component: Layout,
      children: [
        {
          path: routes.home.path,
          name: routes.home.name,
          component: () => import(/* webpackChunkName: "webhome" */ "@/view/pages/HomePublic.vue"),
          props: true,
          meta: {
            shouldDisplayClientWebsiteLink: true,
          },
        },
        {
          path: routes.buybackSearch.path,
          name: routes.buybackSearch.name,
          component: () =>
            import(
              /* webpackChunkName: "websearch" */ "@/apps/whiteLabelWebsite/buyback/view/pages/BuybackWeb/BuybackWebSearch.vue"
            ),
          props: true,
          meta: {
            shouldDisplayClientWebsiteLink: true,
          },
        },
        {
          path: routes.buybackSearchProducts.path,
          name: routes.buybackSearchProducts.name,
          component: () =>
            import(
              /* webpackChunkName: "web" */ "@/apps/whiteLabelWebsite/buyback/view/pages/BuybackWeb/BuybackWebResults.vue"
            ),
          meta: {
            shouldDisplayClientWebsiteLink: true,
          },
        },
        {
          path: routes.buybackSearchByCategories.path,
          name: routes.buybackSearchByCategories.name,
          component: () =>
            import(
              /* webpackChunkName: "web" */ "@/apps/whiteLabelWebsite/buyback/view/pages/BuybackWeb/BuybackWebCategories.vue"
            ),
          props: true,
          beforeEnter: () => {
            if (!checkForNavigationByCategory()) {
              return { name: routes.notFound.name };
            }
          },
          meta: {
            shouldDisplayClientWebsiteLink: true,
          },
        },
        {
          path: routes.buybackSearchCategoryList.path,
          name: routes.buybackSearchCategoryList.name,
          component: () =>
            import(
              /* webpackChunkName: "web" */ "@/apps/whiteLabelWebsite/buyback/view/pages/BuybackWeb/BuybackWebCategory.vue"
            ),
          props: true,
          meta: {
            shouldDisplayClientWebsiteLink: true,
            disableTMSPageViewEvent: true,
          },
        },
        {
          path: routes.buybackCreate.path,
          name: routes.buybackCreate.name,
          component: () =>
            import(
              /* webpackChunkName: "web" */ "@/apps/whiteLabelWebsite/buyback/view/pages/BuybackWeb/BuybackWebCreate.vue"
            ),
          props: (route) => ({
            selectedProductId: route.params.selectedProductId,
            selectedProductSlug: route.params.selectedProductSlug,
            predeclaredBuybackId: route.params?.predeclaredBuybackId,
            itemId: route.params?.itemId,
            goToCartFromOtherRoute: route.query?.goToCartFromOtherRoute,
            fromPath: route.query?.fromPath,
          }),
          meta: {
            disableTMSPageViewEvent: true,
          },
        },
        {
          path: routes.buybackConfirmation.path,
          name: routes.buybackConfirmation.name,
          component: () =>
            import(
              /* webpackChunkName: "web" */ "@/apps/whiteLabelWebsite/buyback/view/pages/BuybackConfirmation/BuybackCreationConfirmation.vue"
            ),
          props: (route) => ({ buybackIdsQuery: route.query.ids }),
          meta: {
            shouldDisplayClientWebsiteLink: true,
            disableTMSPageViewEvent: true,
          },
        },
        {
          path: routes.availableStores.path,
          name: routes.availableStores.name,
          component: () => import(/* webpackChunkName: "web" */ "@/view/pages/AvailableStores/AvailableStores.vue"),
          meta: {
            shouldDisplayClientWebsiteLink: true,
          },
        },
        {
          path: routes.buybackZero.path,
          name: routes.buybackZero.name,
          component: () =>
            import(/* webpackChunkName: "web" */ "@/apps/shared/buyback/view/pages/BuybackWizard/BuybackZero.vue"),
          meta: {
            disableTMSPageViewEvent: true,
          },
        },
        ...buybackRouterWeb,
        ...routerWhiteLabel,
      ],
    },
    {
      path: routes.createBuyback.path,
      name: routes.createBuyback.name,
      redirect: routes.buybackSearch.path,
    },
    {
      path: routes.organizationCgu.path,
      name: routes.organizationCgu.name,
      component: () => import(/* webpackChunkName: "legals" */ "@/view/pages/Legals/Legals.vue"),
    },
    {
      path: routes.organizationCgs.path,
      name: routes.organizationCgs.name,
      component: () => import(/* webpackChunkName: "legals" */ "@/view/pages/Legals/Legals.vue"),
    },
    {
      path: routes.organizationFaq.path,
      name: routes.organizationFaq.name,
      component: () => import(/* webpackChunkName: "legals" */ "@/view/pages/Legals/Legals.vue"),
    },
    {
      path: routes.catchAll.path,
      name: routes.catchAll.name,
      redirect: "/",
    },
    {
      path: routes.notFound.path,
      name: routes.notFound.name,
      component: () => import(/* webpackChunkName: "error" */ "@/view/pages/Error/Error-1.vue"),
    },
    {
      path: routes.notAvailable.path,
      name: routes.notAvailable.name,
      component: () => import(/* webpackChunkName: "not-available" */ "@/view/layout/NotAvailableLayout.vue"),
    },
  ],
});

routerWeb.afterEach(() => scrollTop());

export default routerWeb;
